import { FileTypeData } from "../../types/documents";

/** ファイル種類データプロパティか？ */
export const isPropertyOfFileTypeData = (
  value: string | null
): value is keyof FileTypeData => {
  let result = false;
  if (value) {
    result = ["pdf", "doc", "xls", "ppt", "txt"].includes(value);
  }
  return result;
};
